import { createContext, FC, useContext, useEffect, useMemo } from 'react';
import {
  CommonContext,
  MediaType,
  useApi,
  useCurrentMediaType,
} from '@repo-level/core-front';

import { useAuthCookies } from 'hooks/authCookies';
import { brandAssets, BrandAssets } from 'api/cms/brandAssets';
import { Country, LIVESPINS_RESTRICTED } from 'helpers/conf';

export interface CommonUtilsContextData {
  isMobile: boolean;
  isMobileS: boolean;
  brandAssetsData?: BrandAssets;
  isLiveSpinsAvailable: boolean;
}

export const CommonUtilsContext = createContext<CommonUtilsContextData>(
  null as any
);

export const CommonUtilsContextProvider: FC = ({ children }) => {
  const currentMediaType = useCurrentMediaType();
  const { currentIp } = useContext(CommonContext);

  useAuthCookies();

  const isMobile = useMemo(() => {
    switch (currentMediaType) {
      case MediaType.MOBILE:
      case MediaType.MOBILE_S:
        return true;
      default:
        return false;
    }
  }, [currentMediaType]);

  const isMobileS = useMemo(() => currentMediaType === MediaType.MOBILE_S, [
    currentMediaType,
  ]);

  const isLiveSpinsAvailable = useMemo(() => {
    if (!currentIp) return false;
    return !LIVESPINS_RESTRICTED.includes(currentIp.countryCode as Country);
  }, [currentIp]);

  const [requestBrandAssets, { data: brandAssetsData }] = useApi(brandAssets);

  useEffect(() => {
    requestBrandAssets();
  }, [requestBrandAssets]);

  return (
    <CommonUtilsContext.Provider
      value={{
        isMobile,
        isMobileS,
        brandAssetsData,
        isLiveSpinsAvailable,
      }}
    >
      {children}
    </CommonUtilsContext.Provider>
  );
};
